import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store'
import { Setting } from '../../modules/settings'
import { SettingState, settingStoreKey } from './setting.state'

const getSettings = (state: SettingState): Setting[] => state.settings

export const selectSettingState: MemoizedSelector<object, SettingState> =
  createFeatureSelector<SettingState>(settingStoreKey)
export const selectSettings: MemoizedSelector<object, Setting[]> = createSelector(selectSettingState, getSettings)
